import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import { Cover } from 'ui-toolkit';
import { IEditContactFormProps } from '../interfaces/IEditContactFormProps';
import { ILenderContactData } from '../../../../types/contacts/ILenderContact';
import { Grid, SideSheet } from 'ui-toolkit';
import { SideSheetEditContactFormFooter } from '../../../shared/SideSheetEditContactFormFooter';
import { EditContactFormStatusWrapper } from '../subComponents/EditContactFormStatusWrapper';
import { LenderOrderContactForm } from './LenderOrderContactForm';
import { DeleteContactWarning } from '../subComponents/DeleteContactWarning';
import { lenderOrderContactFormValidation } from '../../../../validation/order/LenderOrderContactFormValidation';

interface IEditLenderOrderContactFormProps extends IEditContactFormProps {
  initialData: ILenderContactData;
}

export const EditLenderOrderContactForm: React.FC<IEditLenderOrderContactFormProps> = ({
  initialData,
  onSubmit,
  onCancel,
  onDelete,
  updateFetchError,
  updateFetchStatus,
  deleteFetchError,
  deleteFetchStatus,
  onResetDeleteContact,
}) => {
  const [showDeleteWarning, setShowDeleteWarning] = useState(false);

  const showWarning = () => setShowDeleteWarning(true);
  const onResetThenCancel = () => {
    onResetDeleteContact();
    onCancel();
  };
  const onCancelDelete = () => {
    setShowDeleteWarning(false);
    onCancel();
  };

  return (
    <Formik
      initialValues={initialData}
      validateOnMount={true}
      validationSchema={lenderOrderContactFormValidation}
      onSubmit={onSubmit}
      onReset={onCancel}
    >
      <Form>
        <SideSheet
          title={'Edit Contact'}
          onClose={onCancel}
          footer={
            <SideSheetEditContactFormFooter
              showWarning={showWarning}
              onCancel={onCancel}
              saveButtonText={'Save and Update'}
            />
          }
        >
          <Grid>
            <EditContactFormStatusWrapper
              fetching={updateFetchStatus.fetching || deleteFetchStatus.fetching}
              updateFetchedSuccess={updateFetchStatus.success}
              deleteFetchedSuccess={deleteFetchStatus.success}
              updateSuccessMessage={'Contact Updated!'}
              deleteSuccessMessage={'Contact Deleted!'}
              fetchError={updateFetchError || deleteFetchError}
              onResetDeleteAndCancel={onResetThenCancel}
            />
            <LenderOrderContactForm emailReadOnly={true} />
            {showDeleteWarning && (
              <Cover>
                <DeleteContactWarning
                  onCancel={onCancelDelete}
                  onDelete={onDelete}
                  contactId={initialData.id}
                  contactName={`${initialData.firstName} ${initialData.lastName}`}
                />
              </Cover>
            )}
          </Grid>
        </SideSheet>
      </Form>
    </Formik>
  );
};
